let checkUser = () => {
  let user = JSON.parse(localStorage.getItem("user"));
  if (user) {
    return true;
  } else {
    return false;
  }
};

exports.baseURL = process.env.VUE_APP_URL;
exports.verNum = process.env.VUE_APP_VERSION_NUMBER;
exports.token = process.env.VUE_APP_TOKEN;
exports.checkUser = checkUser;
